import React from 'react';
import { NavLink as RouterLink, useLocation } from 'react-router-dom';
import PropTypes from 'prop-types';
import {
  Button, ListItem, Collapse, List, useTheme
} from '@mui/material';
import {
  ExpandLess,
  ExpandMore
} from '@mui/icons-material';

const sx = {
  item: {
    display: 'flex',
    paddingTop: 0,
    paddingBottom: 0
  },
  blockItem: {
    display: 'block',
    paddingTop: 0,
    paddingBottom: 0
  },
  button: {
    '&.MuiButtonBase-root': {
      color: 'text.secondary',
      fontWeight: 'fontWeightMedium',
      justifyContent: 'flex-start',
      letterSpacing: 0,
      padding: '10px 8px',
      textTransform: 'none',
      width: '100%',
      borderLeft: '3px solid transparent',
    },
  },
  buttonActive: {
    '&.MuiButtonBase-root': {
      color: 'primary.main',
      backgroundColor: 'action.selected',
      fontWeight: 'fontWeightBold',
      borderLeft: '3px solid',
      borderLeftColor: 'primary.main',
    },
  },
  title: {
    marginRight: 'auto'
  },
  subList: {
    paddingLeft: '16px',
    paddingTop: '4px',
    paddingBottom: '4px'
  },
};

const NavItem = ({
  className,
  href,
  icon: Icon,
  title,
  buttonType,
  buttonMap,
  ...rest
}) => {
  const theme = useTheme();
  const location = useLocation();
  const [open, setOpen] = React.useState(false);
  const handleClick = () => {
    setOpen(!open);
  };
  const notCollapse = (event) => {
    event.stopPropagation();
  };
  const iconStyle = { marginRight: theme.spacing(1) };
  const subTitleStyle = { fontWeight: theme.typography.fontWeightRegular };

  return (
    <div>
      {
        buttonType === 'boton'
          ? (
            <ListItem
              sx={sx.item}
              className={className}
              disableGutters
              {...rest}
              component="div"
            >
              <Button
                sx={[sx.button, location.pathname === href && sx.buttonActive]}
                component={RouterLink}
                to={href}
              >
                {Icon && (
                  <Icon
                    style={iconStyle}
                    size="20"
                  />
                )}
                <span style={sx.title}>
                  {title}
                </span>
              </Button>
            </ListItem>
          )
          : (
            <ListItem
              onClick={handleClick}
              sx={sx.blockItem}
              className={className}
              disableGutters
              {...rest}
              component="div"
            >
              <Button
                sx={[
                  sx.button,
                  buttonMap.some((subItem) => subItem.href === location.pathname)
                  && sx.buttonActive
                ]}
              >
                {Icon && (
                  <Icon
                    style={iconStyle}
                    size="20"
                  />
                )}
                <span style={sx.title}>
                  {title}
                </span>
                {open ? <ExpandLess /> : <ExpandMore />}
              </Button>
              <Collapse in={open} timeout="auto" unmountOnExit>
                <List component="div" disablePadding sx={sx.subList}>
                  <ListItem
                    sx={sx.blockItem}
                    className={className}
                    disableGutters
                  >
                    {buttonMap.map((subItem) => (
                      <Button
                        key={`'button_'${subItem.title}`}
                        sx={[
                          sx.button,
                          subItem.href === location.pathname && sx.buttonActive
                        ]}
                        component={RouterLink}
                        to={subItem.href}
                        onClick={notCollapse}
                      >
                        <span style={subTitleStyle}>
                          {subItem.title}
                        </span>
                      </Button>
                    ))}
                  </ListItem>
                </List>
              </Collapse>
            </ListItem>
          )
      }
    </div>
  );
};

NavItem.propTypes = {
  className: PropTypes.string,
  href: PropTypes.string,
  icon: PropTypes.elementType,
  title: PropTypes.string,
  buttonType: PropTypes.string,
  buttonMap: PropTypes.array
};

export default NavItem;
